<!-- Gate de jornada (TECNICO / SUPERVISOR) -->

<!-- Iniciar jornada: bloquea la app hasta registrar las herramientas -->
<p-dialog [visible]="state.requiresStart()" [modal]="true" [closable]="false" [closeOnEscape]="false"
    [dismissableMask]="false" [draggable]="false" [resizable]="false" styleClass="session-gate-dialog"
    [style]="{ width: '780px', maxWidth: '96vw' }">
    <ng-template #header>
        <div class="gate-header">
            <div class="gate-icon start"><i class="pi pi-play-circle"></i></div>
            <div>
                <h3 class="gate-title">Estado de Herramientas Asignadas</h3>
                <p class="gate-sub">Antes de comenzar tu jornada, registrá el estado de tus herramientas asignadas.</p>
            </div>
        </div>
    </ng-template>

    <div class="gate-body">
        <div class="gate-alert">
            <i class="pi pi-info-circle"></i>
            <span>Completá todas las herramientas asignadas. No podrás iniciar actividades mientras haya alguna pendiente.</span>
        </div>

        <div class="tool-progress">
            <div class="tool-progress-label">
                <span>Herramienta {{ stepNumber() }} de {{ drafts().length }}</span>
                <strong>{{ progressPercent() }}%</strong>
            </div>
            <div class="tool-progress-track">
                <div class="tool-progress-fill" [style.width.%]="progressPercent()"></div>
            </div>
        </div>

        @for (d of currentDraftList(); track d.idTool + ':' + formVersion()) {
        <div class="tool-row" [class.warning]="d.condition !== 'BUENO'">
            <div class="tool-row-head">
                <span class="tool-name"><i class="pi pi-wrench"></i> {{ d.toolName }}</span>
                <p-select [options]="conditionOptions" optionLabel="label" optionValue="value"
                    [ngModel]="d.condition" (ngModelChange)="setCondition(d.idTool, $event)"
                    styleClass="condition-select" appendTo="body" />
            </div>
            <div class="tool-row-grid">
                <div class="tool-photo">
                    <label class="tool-label">
                        Foto <span class="req">{{ d.condition === 'FALTANTE' ? '(opcional)' : '*' }}</span>
                    </label>
                    <app-attachment-uploader module="tools" [maxFiles]="1" [imagesOnly]="true" [immediate]="true"
                        uploadPath="tickets/upload-attachment" (filesChanged)="onFilesChanged(d.idTool, $event)" />
                </div>
                <div class="tool-fields">
                    <label class="tool-label">Nota (opcional)</label>
                    <textarea pInputTextarea rows="2" [ngModel]="d.comment"
                        (ngModelChange)="setComment(d.idTool, $event)"
                        placeholder="Ej: se entrega en buen estado"></textarea>

                    @if (d.condition !== 'BUENO') {
                    <label class="tool-label req">Motivo *</label>
                    <textarea pInputTextarea rows="2" [ngModel]="d.reason"
                        (ngModelChange)="setReason(d.idTool, $event)"
                        placeholder="Indicá por qué está dañada o faltante"></textarea>
                    }
                </div>
            </div>
        </div>
        }
    </div>

    <ng-template #footer>
        <div class="gate-footer">
            <span class="gate-hint" [class.ready]="allValid()">
                @if (allValid()) { <i class="pi pi-check-circle"></i> Todo listo para iniciar }
                @else { <i class="pi pi-exclamation-circle"></i> Completá esta herramienta para continuar }
            </span>
            <div class="gate-actions">
                @if (currentIndex() > 0) {
                <button class="btn-secondary" [disabled]="saving()" (click)="previousTool()">
                    <i class="pi pi-arrow-left"></i> Anterior
                </button>
                }
                <button class="btn-primary"
                    [disabled]="saving() || !currentValid() || (isLastTool() && !allValid())"
                    (click)="advanceStart()">
                    @if (saving()) { <i class="pi pi-spin pi-spinner"></i> }
                    @else if (isLastTool() && allValid()) { <i class="pi pi-play"></i> }
                    @else { <i class="pi pi-arrow-right"></i> }
                    @if (saving()) { Iniciando… }
                    @else if (isLastTool() && allValid()) { Iniciar Actividades }
                    @else if (isLastTool()) { Completar todas las herramientas }
                    @else { Continuar a la siguiente herramienta }
                </button>
            </div>
        </div>
    </ng-template>
</p-dialog>

<!-- Finalizar jornada -->
<p-dialog [(visible)]="state.endDialogVisible" [modal]="true" [closable]="true" [draggable]="false"
    [resizable]="false" [style]="{ width: '780px', maxWidth: '96vw' }" styleClass="session-gate-dialog"
    (onHide)="state.closeEndDialog()">
    <ng-template #header>
        <div class="gate-header">
            <div class="gate-icon end"><i class="pi pi-stop-circle"></i></div>
            <div>
                <h3 class="gate-title">Estado de Herramientas Asignadas</h3>
                <p class="gate-sub">Registrá el estado final de cada herramienta asignada.</p>
            </div>
        </div>
    </ng-template>

    <div class="gate-body">
        <div class="gate-alert">
            <i class="pi pi-info-circle"></i>
            <span>Completá todas las herramientas asignadas. No podrás finalizar mientras haya alguna pendiente.</span>
        </div>

        <div class="tool-progress">
            <div class="tool-progress-label">
                <span>Herramienta {{ stepNumber() }} de {{ drafts().length }}</span>
                <strong>{{ progressPercent() }}%</strong>
            </div>
            <div class="tool-progress-track">
                <div class="tool-progress-fill" [style.width.%]="progressPercent()"></div>
            </div>
        </div>

        @for (d of currentDraftList(); track d.idTool + ':' + formVersion()) {
        <div class="tool-row" [class.warning]="d.condition !== 'BUENO'">
            <div class="tool-row-head">
                <span class="tool-name"><i class="pi pi-wrench"></i> {{ d.toolName }}</span>
                <p-select [options]="conditionOptions" optionLabel="label" optionValue="value"
                    [ngModel]="d.condition" (ngModelChange)="setCondition(d.idTool, $event)"
                    styleClass="condition-select" appendTo="body" />
            </div>
            <div class="tool-row-grid">
                <div class="tool-photo">
                    <label class="tool-label">
                        Foto <span class="req">{{ d.condition === 'FALTANTE' ? '(opcional)' : '*' }}</span>
                    </label>
                    <app-attachment-uploader module="tools" [maxFiles]="1" [imagesOnly]="true" [immediate]="true"
                        uploadPath="tickets/upload-attachment" (filesChanged)="onFilesChanged(d.idTool, $event)" />
                </div>
                <div class="tool-fields">
                    <label class="tool-label">Nota de cierre (opcional)</label>
                    <textarea pInputTextarea rows="2" [ngModel]="d.comment"
                        (ngModelChange)="setComment(d.idTool, $event)"
                        placeholder="Ej: se devuelve completa y funcionando"></textarea>

                    @if (d.condition !== 'BUENO') {
                    <label class="tool-label req">Motivo *</label>
                    <textarea pInputTextarea rows="2" [ngModel]="d.reason"
                        (ngModelChange)="setReason(d.idTool, $event)"
                        placeholder="Indicá qué pasó con la herramienta durante la jornada"></textarea>
                    }
                </div>
            </div>
        </div>
        }
    </div>

    <ng-template #footer>
        <div class="gate-footer">
            <button class="btn-secondary" (click)="state.closeEndDialog()">
                <i class="pi pi-times"></i> Cancelar
            </button>
            <div class="gate-actions">
                @if (currentIndex() > 0) {
                <button class="btn-secondary" [disabled]="saving()" (click)="previousTool()">
                    <i class="pi pi-arrow-left"></i> Anterior
                </button>
                }
                <button [class.btn-primary]="!isLastTool()" [class.btn-danger]="isLastTool()"
                    [disabled]="saving() || !currentValid() || (isLastTool() && !allValid())"
                    (click)="advanceEnd()">
                    @if (saving()) { <i class="pi pi-spin pi-spinner"></i> }
                    @else if (isLastTool() && allValid()) { <i class="pi pi-stop-circle"></i> }
                    @else { <i class="pi pi-arrow-right"></i> }
                    @if (saving()) { Finalizando… }
                    @else if (isLastTool() && allValid()) { Finalizar jornada }
                    @else if (isLastTool()) { Completar todas las herramientas }
                    @else { Continuar a la siguiente herramienta }
                </button>
            </div>
        </div>
    </ng-template>
</p-dialog>

<!-- Aviso: jornada anterior sin cerrar -->
<p-dialog [visible]="state.staleWarningVisible()" [modal]="true" [closable]="false" [closeOnEscape]="false"
    [dismissableMask]="false" [draggable]="false" [resizable]="false" styleClass="session-gate-dialog"
    [style]="{ width: '560px', maxWidth: '96vw' }">
    <ng-template #header>
        <div class="gate-header">
            <div class="gate-icon warning"><i class="pi pi-exclamation-triangle"></i></div>
            <div>
                <h3 class="gate-title">Jornada anterior sin cerrar</h3>
                <p class="gate-sub">Quedó una jornada abierta de un día anterior.</p>
            </div>
        </div>
    </ng-template>

    <div class="gate-body">
        <div class="gate-alert warning-alert">
            <i class="pi pi-clock"></i>
            <span>
                Iniciaste una jornada el
                <strong>{{ state.activeSession()?.startTime | date:'dd/MM/yyyy HH:mm' }}</strong>
                y no la finalizaste. Podés continuarla o cerrarla para iniciar una nueva.
            </span>
        </div>
    </div>

    <ng-template #footer>
        <div class="gate-footer">
            <button class="btn-primary" (click)="state.continueCurrentSession()">
                <i class="pi pi-play"></i> Continuar jornada
            </button>
            <button class="btn-danger" (click)="state.closeStaleSession()">
                <i class="pi pi-stop-circle"></i> Cerrar y reiniciar
            </button>
        </div>
    </ng-template>
</p-dialog>
